const FEATURE_FLAGS = {
  UP_NAVIGATION_FLAG: "upNavbar",
  NEW_ANALYTICS_FLAG: "showNewAnalytics",
};

export { FEATURE_FLAGS };
